import { render } from "./sharepointImagePreviewModal.vue?vue&type=template&id=9d85dc66&scoped=true"
import script from "./sharepointImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./sharepointImagePreviewModal.vue?vue&type=script&lang=js"

import "./sharepointImagePreviewModal.vue?vue&type=style&index=0&id=9d85dc66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d85dc66"]])

export default __exports__